
import axios from 'axios'
import { authHeader } from '@/services/auth'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

/**
 * @param filters
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function getVisites (filters) {
  if (filters.post && filters.post.advertiser) {
    let url = processEnvConfig.VUE_APP_HYPER_ESPACE_API_URL + '/v2/visites?idAnnonceur=' + filters.post.advertiser.id
    if (filters.post.reference) {
      url += '&refAnnonce=' + filters.post.reference
    }
    if (filters.status) {
      url += '&status=' + filters.status
    }
    if (filters.withAds) {
      url += '&withAds=' + filters.withAds
    }
    if (filters.page) {
      url += '&page=' + filters.page
    }
    if (filters.size) {
      url += '&size=' + filters.size
    }
    if (filters.sort) {
      url += '&sort=' + filters.sort
    }
    if (filters.direction) {
      url += '&direction=' + filters.direction
    }
    try {
      const response = await axios.get(url, { headers: authHeader() })
      return response.data
    } catch (error) {
      console.error('Error making the request:', error)
      throw error
    }
  } else {
    return []
  }
}

/**
 * @param visite
 * @returns {Promise<void>}
 */
export async function saveVisite (visite) {
  return HTTP_HYPER_ESPACE_BACKEND.post('/v2/visite/add', visite)
}
